import { jsx as _jsx } from "react/jsx-runtime";
import createCache from '@emotion/cache';
import { CacheProvider } from "@emotion/react";
export const muiCache = createCache({
    'key': 'mui',
    'prepend': true,
});
export default (props) => {
    return (_jsx(CacheProvider, Object.assign({ value: muiCache }, { children: props.children })));
};
//# sourceMappingURL=index.js.map